import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import WhyChooseUs from "@/components/WhyChooseUs";
import Jobs from "@/components/Jobs";
import Industries from "@/components/Industries";
import Services from "@/components/Services";
import Testimonials from "@/components/Testimonials";
import Resources from "@/components/Resources";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ApplyDialog from "@/components/ApplyDialog";
import WhatsAppButton from "@/components/WhatsAppButton";
import EmailPopup from "@/components/EmailPopup";
import Admin from "@/pages/Admin";

const DEFAULT_FILTERS = { q: "", location: "", industry: "All Industries" };

function HomePage() {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [applyJob, setApplyJob] = useState(null);

  return (
    <div className="bg-[#F4F5F7]">
      <Navbar />
      <Hero onSearch={(f) => setFilters({ ...DEFAULT_FILTERS, ...f })} />
      <Marquee />
      <Jobs filters={filters} setFilters={setFilters} onApply={setApplyJob} />
      <WhyChooseUs />
      <Industries onSelectIndustry={(name) => setFilters({ ...DEFAULT_FILTERS, industry: name })} />
      <Services />
      <Testimonials />
      <Resources />
      <Contact />
      <Footer />
      <ApplyDialog job={applyJob} onClose={() => setApplyJob(null)} />
      <WhatsAppButton />
      <EmailPopup />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
